import { useState } from 'react';
import { faqList } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqList.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
              常见问题
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              关于hth，您可能想了解的问题
            </p>
          </div>

          <div className="space-y-3">
            {faqList.map((item, index) => (
              <div
                key={index}
                className="border border-background-200 rounded-lg overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50 transition-colors"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                    {item.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 flex-shrink-0 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {openIndex === index && (
                  <div className="px-5 pb-4 pt-0">
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}